import { Button, Select } from "antd";
import React from "react";
import alarm from "../../../Assets/Icons/alarm (1) 1.svg";
import telegram from "../../../Assets/Icons/telegram 1.svg";
import "../../../Components/PageLayout/NotificationDrawer/style.css";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDate } from "../../../Utils/formatDate";

const { Option } = Select;

const Notifications = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const notifications = location.state?.notifications || [];
  

  const handleViewDetails = (id) => {
    navigate(`/view-notification-detail/${id}`);
  };

  return (
    <div style={{ border: "none", marginTop: "19px" }} className="notification-drawer">

      <div className="list-notifications">
        {notifications.map((notification) => (
          <div className="container">
            <div className="head">
              <div className="title">
                <img src={alarm} alt="Alarm" />
                {notification?.title}
              </div>
              <div className="score">{notification?.score}</div>
            </div>
            <div className="desc">{notification?.subtitle}</div>
            <div className="footer">
              <div className="status">
                {formatDate(notification?.created_at)}
              </div>
              <Button onClick={() => handleViewDetails(notification?.id)}>
                View Details
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notifications;
